export function IllustrationBusinessModel({ className }: { className?: string }) {
  return (
    <img
      className={className}
      src="/images/atelier-expedition.webp"
      alt="Emballage et expédition de produits reconditionnés"
      loading="lazy"
      style={{ borderRadius: 'var(--radius-md)', objectFit: 'cover' }}
    />
  );
}
